const toDataUrl = (content, mimeType) => `data:${mimeType};base64,${content}`;

export {
    toDataUrl
}